<div class="itb-feedback-container">
  <div class="feedback-browser">
    <div class="browser-top">
      <strong class="header-text">
        <itb-text [className]="'text-default'" [text]="'Feedback Page'"></itb-text>
      </strong>
      <div class="browser-icons">
        <div class="red"></div>
        <div class="yellow"></div>
        <div class="green"></div>
      </div>
    </div>
    <div class="browser-body">
      <div class="display-center">
          <div class="feedback-header">
              <div class="header-image">
                <img src="{{imagePath}}" width="150" />
              </div>
            </div>
            <div>
              <div *ngIf="editTitleText === false">
                <h4>
                  {{ tempTitle }}
                  <itb-icon [hidden]="isDisabled" [tooltipText]="'Update'" [className]="'edit'" (onClickHandler)="editTitleTextFunc()"></itb-icon>
                </h4>
              </div>
      
              <div class="text-edit" *ngIf="editTitleText === true">
                <div>
                  <form class="form-horizontal">
                      <itb-textarea [isReactive]=false [rows]="'10'" [placeholder]="" [value]= "tempTitle"
                      [maxlength]="titleTextFormsMaxLength" (onTextChangeHandler)="onTitleTextChange($event)"></itb-textarea>
                  </form>
                </div>
                <div class="edit-icon">
                  <itb-icon [hidden]="tempTitle.trim().length === 0" [tooltipText]="'Save'" [className]="'save'"
                    (onClickHandler)="onChangeEvent('titleTextForms')"></itb-icon>
                  <itb-icon [tooltipText]="'Cancel'" [className]="'cross'" (onClickHandler)="editTitleTextFunc()"></itb-icon>
                </div>
              </div>
            </div>
            <div>
              <div *ngIf="editDetailsText === false">
                <p class="text-default fd">
                  <itb-text [className]="'text-default'" [text]="tempDetails"></itb-text>
                  <itb-icon [hidden]="isDisabled" [tooltipText]="'Update'" [className]="'edit'" (onClickHandler)="editDetailTextFunc()"></itb-icon>
                </p>
              </div>
      
              <div class="text-edit" *ngIf="editDetailsText">
                <div>
                  <form class="form-horizontal">
                    <itb-textarea [isReactive]=false [rows]="'10'" [placeholder]="" [value]="tempDetails"
                      [maxlength]="detailsTextFormMaxLength" (onTextChangeHandler)="onDetailsTextChange($event)"></itb-textarea>
                  </form>
                </div>
                <div class="edit-icon">
                  <itb-icon [hidden]="tempDetails.trim().length === 0" [tooltipText]="'Save'" [className]="'save'"
                    (onClickHandler)="onChangeEvent('detailsTextForm')"></itb-icon>
                  <itb-icon [tooltipText]="'Cancel'" [className]="'cross'" (onClickHandler)="editDetailTextFunc()"></itb-icon>
                </div>
              </div>
            </div>
            <div class="fdt-ng-content">
                <ng-content ></ng-content>
            </div>            
            <div>
              <div *ngIf="editCopyrightText === false">
                <p class="text-default">
                  <itb-text [className]="'text-default'" [text]="tempCopyrights"></itb-text>
                  <itb-icon [hidden]="isDisabled" [tooltipText]="'Update'" [className]="'edit'" (onClickHandler)="editCopyrightTextFunc()"></itb-icon>
                </p>
              </div>
      
              <div class="text-edit" *ngIf="editCopyrightText === true">
                <div>
                  <form class="form-horizontal">
                    <itb-textarea [isReactive]=false [rows]="'10'" [placeholder]="" [value]="tempCopyrights"
                      [maxlength]="copyrightTextFormMaxLength" (onTextChangeHandler)="onCopyrightsTextChange($event)"></itb-textarea>
                  </form>
                </div>
                <div class="edit-icon">
                  <itb-icon [hidden]="tempCopyrights.trim().length === 0" [tooltipText]="'Save'" [className]="'save'"
                    (onClickHandler)="onChangeEvent('copyrightTextForm')"></itb-icon>
                  <itb-icon [tooltipText]="'Cancel'" [className]="'cross'" (onClickHandler)="editCopyrightTextFunc()"></itb-icon>
                </div>
              </div>
            </div>
      </div>
      
    </div>
  </div>
</div>